import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import dynamicfunction from '../../../../utils/dynamicfunction';
import Text from '../../../../components/Text';
import { COLORS, fontSizes } from '../../../../constants/constants';

const RadioButton = ({ value, onChange, label, required = true, options, keyValue = 'name', returnFullObject = false , labelDivClass = false, }) => {
  const { isArabic } = dynamicfunction();

  return (
    <div>
      {label && (
        <div className={labelDivClass}> 
          <Text text={label} size={fontSizes?.h14} isTruncate={false} isRequired={required} className={'leading-4'} />
        </div>
      )}

      <RadioGroup
        row
        value={value ?? ''}
        onChange={(e) => {
          const selectedId = e.target.value;
          const selectedOption = options.find((opt) => String(opt.id) === selectedId);
          if (returnFullObject) {
            onChange(selectedOption);
          } else {
            onChange(selectedId);
          }
        }}
        sx={{
          mt: 0,
          // justifyContent: isArabic ? 'flex-end' : 'flex-start',
          flexDirection: isArabic ? "row-reverse" : "row",
          '& svg': {
            width: 20,
            height: 20,
          },
          '&.Mui-disabled': {
            opacity: 0.5,
          },
        }}
      >
        {options && options?.length > 0 ? (
          options?.map((item) => (
            <FormControlLabel
              key={item?.id}
              value={item.id}
              control={
                <Radio
                  sx={{
                    '&.Mui-checked': {
                      color: COLORS.primary,
                    },
                  }}
                />
              }
              label={item?.[keyValue]}
              labelPlacement={isArabic ? 'start' : 'end'}
              componentsProps={{
    typography: {
      fontSize: fontSizes?.h14,
      color: COLORS.neutral_grey, // optional
    },
  }}
            />
          ))
        ) : (
          <Text text='No Data Available' />
        )}
      </RadioGroup>
    </div>
  );
};

export default RadioButton;
